export const FETCH_NEWS_ITEM_ATTEMPT = '[News Items] Fetch News Item Attempt';
export const FETCH_NEWS_ITEM_SUCCESS = '[News Items] Fetch News Item Success';
export const FETCH_NEWS_ITEM_FAILURE = '[News Items] Fetch News Item Failure';
export const FETCH_NEWS_ITEM_SKIPPED = '[News Items] Fetch News Item Skipped';
export const CLEAR_NEWS_ITEM = '[News Items] Clear News Item';
